module.exports = __webpack_public_path__ + "static/media/shoprite-card-barcode.4019a36b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shoprite-card-barcode.png
// module id = 345
// module chunks = 0